import { getUserQueryData } from "@certa/queries/hooks/authV2.hooks";

/**
 * Used by SelectLanguage component which is used in Header and LoginPage so user may not exist in the query data. AuthenticationProvider is not loaded at this point.
 */
export const useUserPreferredLanguage = (): string | null => {
  const user = getUserQueryData();
  return user?.prefered_language || null;
};
